import '~/js/libs/slick-carousel';

import popovers from '~/js/modules/popovers';

function listGridViewer() {

    popovers();

    //select for mobile tabs
    $('.valueText').click(function(){
        var dropBlock = $(this).parent().find('.selectList');
        if( dropBlock.is(':hidden') ) {
            dropBlock.slideDown();

            $(this).addClass('active');

            $('.selectList').find('a').click(function(){

                var selectResult = $(this).html();

                $(this).parent().parent().find('input').val(selectResult);

                $('.valueText').removeClass('active').html(selectResult);

                dropBlock.slideUp();
            });

        } else {
            $(this).removeClass('active');
            dropBlock.slideUp();
        }

        return false;
    });
}

export default listGridViewer;